import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

interface ChatMessage {
  id: string;
  text: string;
  sender: 'user' | 'system';
  timestamp: Date;
}

@Component({
  selector: 'qt-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatCardModule,
    MatTooltipModule,
    TextFieldModule,
  ],
})
export class ChatComponent implements OnInit, AfterViewInit {
  @ViewChild('messageContainer')
  private messageContainer!: ElementRef<HTMLDivElement>;
  messages = signal<ChatMessage[]>([]);
  newMessage = signal<string>('');
  isLoading = signal<boolean>(false);

  ngOnInit(): void {
    this.addSystemMessage('Welcome to the chat! How can I help you today?');
    this.addUserMessage('Hello. Could you help me to find some deal?');
    this.addSystemMessage('Sure, please type the deal name');
  }

  handleEnterKey(event: Event): void {
    const keyEvent = event as KeyboardEvent;
    if (keyEvent.shiftKey) {
      return;
    }

    event.preventDefault();
    this.sendMessage();
  }

  sendMessage(): void {
    const messageText = this.newMessage();
    if (!messageText.trim()) return;

    this.addUserMessage(messageText);
    this.newMessage.set('');

    // Simulate response (in a real app, this would call a service)
    this.isLoading.set(true);
    setTimeout(() => {
      this.addSystemMessage(
        'Thank you for your message. This is a simulated response.'
      );
      this.isLoading.set(false);
    }, 1500);
  }

  private addUserMessage(text: string): void {
    this.addMessage('user', text);
  }

  private addSystemMessage(text: string): void {
    this.addMessage('system', text);
  }

  ngAfterViewInit(): void {
    this.scrollToBottom();
  }

  private addMessage(sender: 'user' | 'system', text: string): void {
    const newMessage: ChatMessage = {
      id: crypto.randomUUID(),
      text,
      sender,
      timestamp: new Date(),
    };

    this.messages.update(messages => [...messages, newMessage]);

    setTimeout(() => this.scrollToBottom(), 0);
  }

  private scrollToBottom(): void {
    if (this.messageContainer) {
      const element = this.messageContainer.nativeElement;
      element.scrollTop = element.scrollHeight;
    }
  }
}
